// service to make a call to cache endpoint and check with the value from localstorage. If the value is same, then do nothing. If the value is different, we cleanup the localstorage and refresh the page.

import { Injectable } from '@angular/core';
import { VersionClient } from 'src/app/web-api-client';

const cacheKey = 'version';

@Injectable(
    { providedIn: 'root' }
)
export class CacheCleanupService {
    constructor(private client: VersionClient) {}

    checkCacheVersion() {
        this.client.get().subscribe((response) => {
            const version = response;
            const localStorageVersion = localStorage.getItem(cacheKey);

            if (!localStorageVersion) {
                localStorage.setItem(cacheKey, version);
                return;
            }

            if (version !== localStorageVersion) {
                localStorage.clear();
                sessionStorage.clear();
                localStorage.setItem(cacheKey, version);
                window.location.reload();
            }
        });
    }
}
